import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=6a96db94&scoped=true"
import script from "./CardForm.vue?vue&type=script&lang=js"
export * from "./CardForm.vue?vue&type=script&lang=js"
import style0 from "./CardForm.vue?vue&type=style&index=0&id=6a96db94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96db94",
  null
  
)

export default component.exports